export default function PrimaryButton({ title, onClick }){
    return(
        <button className='button' onClick={onClick}>
            <span className="text-sm">{title}</span>
        </button>
    )
}